module.exports = __webpack_public_path__ + "static/img/excel-import.d8b2136.png";